<template>
  <div class="audio-recorder">
    <button class="btn cancel-btn" @click="cancleAudio"><p></p></button>
    <div class="recording-controls" v-if="recorded === false">
      <div class="text">
        <p class="start-title" v-if="stopIs === false && recorded === false">
          Press Button to Start Recording
        </p>
        <p class="recording-title" v-if="stopIs === true && recorded === false">
          Recording Audio
        </p>
        <p id="timer" class="recording-title" v-if="stopIs === true && recorded === false">
          <span id="hours">00:</span>
          <span id="mins">00:</span>
          <span id="seconds">00</span>
        </p>
      </div>
      <div class="actions">
        <button class="btn record-btn" v-if="stopIs === false && recorded === false" @click="startRecord">
          <svg width="68" height="68" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M33.7161 40.3455C38.3238 40.3455 42.0155 36.6125 42.0155 31.9881L42.0433 15.2734C42.0433 10.649 38.3238 6.91602 33.7161 6.91602C29.1084 6.91602 25.389 10.649 25.389 15.2734V31.9881C25.389 36.6125 29.1084 40.3455 33.7161 40.3455ZM48.4274 31.9881C48.4274 40.3455 41.3771 46.1956 33.7161 46.1956C26.0552 46.1956 19.0048 40.3455 19.0048 31.9881H14.2861C14.2861 41.4877 21.8361 49.3436 30.9404 50.7086V59.846H36.4919V50.7086C45.5962 49.3714 53.1461 41.5155 53.1461 31.9881H48.4274Z"
              fill="white"
            />
          </svg>
        </button>
        <button class="btn record-btn" v-if="stopIs === true && recorded === false" @click="stopRecorder">
          <svg width="67" height="67" viewBox="0 0 67 67" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17 17H50.5V50.5H17V17Z" fill="white" />
          </svg>
        </button>
      </div>
    </div>
    <div class="recorded-section" v-if="recorded === true">
      <!--      <audio  id="player" controls></audio>-->
      <!-- <div class="uploaded-audio d-flex align-items-center justify-content-between mb-3">
        <div class="audio-info d-flex align-items-center">
          <div class="icon">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16 19.1665C18.2007 19.1665 19.9639 17.3836 19.9639 15.1749L19.9771 7.19177C19.9771 4.9831 18.2007 3.2002 16 3.2002C13.7993 3.2002 12.0228 4.9831 12.0228 7.19177V15.1749C12.0228 17.3836 13.7993 19.1665 16 19.1665ZM23.0263 15.1749C23.0263 19.1665 19.6589 21.9606 16 21.9606C12.341 21.9606 8.97369 19.1665 8.97369 15.1749H6.71997C6.71997 19.712 10.3259 23.4641 14.6743 24.1161V28.4802H17.3257V24.1161C21.674 23.4774 25.28 19.7253 25.28 15.1749H23.0263Z" fill="#313C4E"/>
            </svg>
          </div>
          <div class="text">
            <p class="title">12 March 2021 17:43:05</p>
            <p class="duration">Duration: <span>01:23</span></p>
          </div>
        </div>
        <div class="actions d-flex align-items-center">
          <p class="mb-0 title">Play</p>
          <div class="icon">
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16.6666 27.4997L26.6666 19.9997L16.6666 12.4997V27.4997ZM19.9999 3.33301C10.7999 3.33301 3.33325 10.7997 3.33325 19.9997C3.33325 29.1997 10.7999 36.6663 19.9999 36.6663C29.1999 36.6663 36.6666 29.1997 36.6666 19.9997C36.6666 10.7997 29.1999 3.33301 19.9999 3.33301ZM19.9999 33.333C12.6499 33.333 6.66659 27.3497 6.66659 19.9997C6.66659 12.6497 12.6499 6.66634 19.9999 6.66634C27.3499 6.66634 33.3333 12.6497 33.3333 19.9997C33.3333 27.3497 27.3499 33.333 19.9999 33.333Z" fill="#FF077B"/>
            </svg>
          </div>
        </div>
      </div> -->
      <!-- <audio-player data-src="https://assets.codepen.io/4358584/Anitek_-_Komorebi.mp3"></audio-player> -->
      <CustomAudioRecorder v-if="audioUrl !== ''" :audio-src="audioUrl" :audio-file="blobFile"></CustomAudioRecorder>
      <div class="actions d-flex align-items-center justify-content-between w-100">
        <button class="btn btn-hollow p-0 border-0" @click="retakeAudio" v-if="audioUrl !== '' && recorded === true">
          Retake
        </button>
        <button class="btn btn-solid" @click="submitAudio" v-if="audioUrl !== '' && recorded === true">
          <div class="icon">
            <svg width="17" height="16" viewBox="0 0 17 16" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.22656 10.893L9.2799 7.83301L6.22656 4.77301L7.16656 3.83301L11.1666 7.83301L7.16656 11.833L6.22656 10.893Z" />
            </svg>
          </div>
          Use Recording
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import CustomAudioRecorder from "./CustomAudioRecorder";
import $ from "jquery";
export default {
  props: ["uploadUrl"],
  components: {
    CustomAudioRecorder,
  },
  data() {
    return {
      stopIs: false,
      audioChunks: [],
      mediaRecorder: undefined,
      recorded: false,
      audioUrl: "",
      blobFile: "",
      timex: "",
      seconds: 0,
      mins: 0,
      hours: 0,
      recorderStartDateTime: null,
      // startRecord : false
    };
  },
  beforeCreate() {
    // console.log(this.audioUrl, 'audioUrl')
  },
  methods: {
    goBack() {
      return this.$router.go(-1);
    },
    startRecord() {
      this.stopIs = true;
      try {
        navigator.mediaDevices.getUserMedia({ audio: true }).then((stream) => {
          this.mediaRecorder = new MediaRecorder(stream);
          this.mediaRecorder.start();
          this.recorderStartDateTime = new Date();
          this.startTimer();
          this.mediaRecorder.ondataavailable = (event) => {
            this.audioChunks.push(event.data);
          };
        });
      } catch (e) {
        if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
          console.log("This browser does not support the API yet");
        }
      }
    },
    stopRecorder() {
      this.stopTimer();
      this.recorded = true;
      this.stopIs = false;
      this.mediaRecorder.stop();
      let endRecordTime = new Date();
      let duration = Math.abs((endRecordTime.getTime() - this.recorderStartDateTime.getTime()) / 1000);
      // console.log(duration);
      setTimeout(() => {
        this.blobFile = new Blob(this.audioChunks, { type: "audio/mp3" });
        this.blobFile.duration = duration;
        this.blobFile.startRecordTime = this.recorderStartDateTime;
        this.blobFile.endRecordTime = endRecordTime;
        this.audioChunks = [];
        this.audioUrl = URL.createObjectURL(this.blobFile);
        // console.log(this.audioUrl);
        // console.log(this.blobFile);
        // const audio = document.getElementById('player');
        // audio.src = this.audioUrl;
        // console.log(audio)
      }, 500);
      this.seconds = 0;
      this.mins = 0;
      this.hours = 0;
    },
    startTimer() {
      var this_outer = this;
      this.timex = setTimeout(function() {
        this_outer.seconds++;
        if (this_outer.seconds > 59) {
          this_outer.seconds = 0;
          this_outer.mins++;
          if (this_outer.mins > 59) {
            this_outer.mins = 0;
            this_outer.hours++;
            if (this_outer.hours < 10) {
              $("#hours").text("0" + this_outer.hours + ":");
            } else $("#hours").text(this_outer.hours + ":");
          }

          if (this_outer.mins < 10) {
            $("#mins").text("0" + this_outer.mins + ":");
          } else $("#mins").text(this_outer.mins + ":");
        }
        if (this_outer.seconds < 10) {
          $("#seconds").text("0" + this_outer.seconds);
        } else {
          $("#seconds").text(this_outer.seconds);
        }
        this_outer.startTimer();
      }, 1000);
    },
    stopTimer() {
      clearTimeout(this.timex);
    },
    cancleAudio() {
      this.$emit("close");
    },
    submitAudio() {
      // console.log("from submit", this.blobFile);
      this.$emit("clicked", [this.blobFile, this.audioUrl]);
    },
    retakeAudio() {
      this.stopIs = false;
      this.recorded = false;
      this.recorderStartDateTime = 0;
      this.blobFile = null;
      this.audioUrl = null;
    },
  },
  created() {
    this.$helpers.updateColorAccordingApi();
  },
  mounted() {
    window.addEventListener(
      "message",
      (event) => {
        if (event.origin === "http://localhost:8100" || event.origin === "https://vkstg.larkbase.com" || event.origin === "https://app.vouchkick.com") {
          if (event.data.settings) {
            for (let key in event.data.settings) {
              this.response.settings[key] = event.data.settings[key];
            }
            this.$session.set("response", this.response);
            var this_pointer = this;
            setTimeout(function() {
              this_pointer.$helpers.resizeIframeEvent();
            }, 300);
          }
        }
      },
      false
    );
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.audio-recorder {
  height: 100vh;
  width: 100%;
  margin-top: -16px;
  background: #fff;
  position: relative;

  .recording-controls {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-direction: column;
    // padding-top: 25vh;

    .text {
      // height: 109px;
      .start-title {
        font-family: "Poppins", sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 27px;
        letter-spacing: -0.02em;
        color: #313c4e;
        margin: 0;
      }
      .recording-title {
        font-family: "Poppins", sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 36px;
        line-height: 54px;
        letter-spacing: -0.02em;
        color: #313c4e;
        margin: 0;
        text-align: center;
      }
    }
  }

  .record-btn {
    background: var(--accent-color);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border-radius: 50%;
    width: 100px;
    height: 100px;
  }

  .cancel-btn {
    position: absolute;
    top: 20px;
    right: 20px;

    p {
      &::after {
        content: "";
        width: 3px;
        height: 25px;
        background: var(--accent-color);
        position: absolute;
        border-radius: 10px;
        transform: rotate(-45deg);
      }

      &::before {
        content: "";
        width: 3px;
        height: 25px;
        background: var(--accent-color);
        position: absolute;
        border-radius: 10px;
        transform: rotate(45deg);
      }
    }
  }

  .recorded-section {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 57px 30px;
  }
  .btn-solid {
    font-family: "Poppins", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0.01em;
    color: var(--action-btn-color) !important;
    background: var(--accent-color);
    width: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 35px;
    padding: 0 18px;
    border-radius: 5px;
    .icon {
      margin-right: 8px;
      fill: var(--action-btn-color);
    }
    &:hover {
      color: var(--action-btn-color);
    }
  }
  .btn-hollow {
    font-family: "Poppins", sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.01em;
    color: var(--accent-color);
    border-color: var(--accent-color);
    height: 35px;
    padding: 0 25px;
    &:hover{
    color: var(--accent-color);
    }
    &:active{
      color: var(--accent-color);
    }
  }
}
</style>
